// Fonctionnalités mises de côté pour la version 1 : le moteur reste dans le code, l'interface qui s'y rapporte est masquée et la fonction n'est jamais
// activée. Pour la rendre, passer le drapeau à true (voir aussi les éléments marqués data-feature="…" dans index.html, masqués par ui/features.js).
//   vr : la visée au gyroscope (bouton « VR » du viseur, réglages « Gyroscope », astuce « en mode VR »). Moteur : ui/gyro.js, core/orientation.js,
//        et la section « Gyroscope » de game.js.
export const FEATURES = Object.freeze({ vr: false });
